import React, { Component } from "react";
import { connect } from "react-redux";
import { Container, NavbarToggler, Button, Navbar, Row, Col } from "reactstrap";
import Spinner from "react-spinkit";
import {
	setAuthTokenAction,
	setCurrentRoute,
	toggleSiderBarOpen
} from "../actions/authActions";
// import Filter from './createCampaign/filter';
import SideBarComponent from "./createCampaign/sideBarComponent";
import GoogleMap from "./createCampaign/googleMap";
import Cart from "./createCampaign/cart";
// import { persistor } from "../store";
import Campaigns from "./campaign/campaigns";
import SharedCampaign from "./sharedCampaign/sharedCampaign";
import LocateSites from "./locateSites/locateSites";

class Main extends Component {
	state = {
		showSidebar: true,
		collapsed: true,
		center: { lat: 20.5937, lng: 78.9629 }
	};

	componentDidMount() {
		// const { authToken } = this.props.match.params;
		// const authToken =
		// 	"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiI1OTg5OWQ5MDYwNjEwZDE4ZDBiYzhkMjciLCJpYXQiOjE1NTU2NTcyNTcxNjN9.GFBrt-oKlpL42-RBMpWbRnT0ECy9nub6BIBgFwN_cyQ";

		// this.props.setAuthTokenAction(authToken);

		window.navigator.geolocation.getCurrentPosition(success => {
			this.setState({
				center: { lat: success.coords.latitude, lng: success.coords.longitude }
			});
		});
	}

	handleToggleButtonClick = () => {
		this.setState({ showFilter: !this.state.showSidebar });
	};

	handleResetButton = () => {
		// persistor.purge().then(() => {
		//   window.location.reload();
		// });
		window.location.reload();
	};

	toggleNavbar() {
		this.props.toggleSiderBarOpen(!this.props.sideBarOpen);
	}

	render() {
		const { center } = this.state;

		return (
			<div
				style={{
					overflow: "scroll",
					overflowX: "hidden",
					maxHeight: "100vh",
					maxWidth: "100vw",
					height: "100vh"
				}}
			>
				{this.props.sideBarOpen && <SideBarComponent />}
				
{/* 
				{!this.props.routeName === "create_plano_campaign" && (
						<Row style={{ margin: 0 }}>
							<Navbar
								dark
								className="bg-dark"
								style={{ width: "100vw", height: 50 }}
							>
								<NavbarToggler onClick={this.toggleNavbar.bind(this)} />
								<Button size="sm" color="warning" onClick={this.handleResetButton}>
									Reset
								</Button>
							</Navbar>
						</Row>
			  
				  	 ) 
				}  */}
			  		
				 	

				{this.props.routeName === "create_plano_campaign" && (
					<Row style={{ margin: 0 }}>
						<Col
							sm={this.props.cartItems.length === 0 ? "12" : "9"}
							style={{ padding: 0 }}
						>
							{this.props.sitesLoaded === true ? (
								<GoogleMap
									loadingElement={<div style={{ height: `100%` }} />}
									containerElement={
										<div style={{ height: "100vh", width: "100vw" }} />
									}
									mapElement={<div style={{ height: `100%` }} />}
									center={center}
									zoom={6}
								/>
							) : (
								<Container className="mt-5">
									<h1 className="display-1 text-center">{`Loaded Sites ${
										this.props.searchData.length
									}`}</h1>{" "}
									<Spinner className="text-center" />
								</Container>
							)}
						</Col>
						<Col sm={this.props.cartItems.length === 0 ? "0" : "3"}>
							<Cart />
						</Col>
					</Row>
				)}

				{this.props.routeName === "show_created_campaign" && (
					<Row style={{ margin: 0 }}>
						<Navbar
							dark
							className="bg-light"
							style={{ width: "100vw", height: 50 ,background:"white"}}
						>
							<NavbarToggler onClick={this.toggleNavbar.bind(this)} />
							<Button size="sm" color="warning" style={{padding:"10px"}} onClick={this.handleResetButton}>
								x
							</Button>
						</Navbar>
						<Campaigns center={center} />
					</Row>
				)}

				{this.props.routeName === "show_shared_campaign" && (
					<Row style={{ margin: 0 }}>
						<Navbar
							dark
							className="bg-dark"
							style={{ width: "100vw", height: 50 }}
						>
							<NavbarToggler onClick={this.toggleNavbar.bind(this)} />
							<Button size="sm" color="warning" onClick={this.handleResetButton}>
								Reset
							</Button>
						</Navbar>
						<SharedCampaign center={center} />
					</Row>
				)}

				{this.props.routeName === "locate_sites" && (
					<Row style={{ margin: 0 }}>
						<Navbar
							dark
							className="bg-dark"
							style={{ width: "100vw", height: 50 }}
						>
							<NavbarToggler onClick={this.toggleNavbar.bind(this)} />
							<Button size="sm" color="warning" onClick={this.handleResetButton}>
								Reset
							</Button>
						</Navbar>
						<LocateSites center={center} />
					</Row>
				)}
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		searchData: state.filter.searchData,
		sitesLoaded: state.filter.sitesLoaded,
		routeName: state.auth.routeName,
		sideBarOpen: state.auth.sideBarOpen,
		cartItems: state.cart.cartItems
	};
};

export default connect(
	mapStateToProps,
	{ setAuthTokenAction, setCurrentRoute, toggleSiderBarOpen }
)(Main);



// WEBPACK FOOTER //
// ./src/v3/components/main.js